import { ErrorModal } from "@dexteel/mesf-core";
import { Autocomplete, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { getCrews } from "../../repositories/DelaysReportRepository";

export const useCrews = (onError?: (error: Error) => void) => {
	return useQuery<String[], Error>({
		queryKey: ["crews"],
		queryFn: ({ signal }) => getCrews(signal),
		onError: onError,
	});
};

type Props = {
	value: string | null;
	onChange: (value: string | null) => void;
};

export const CrewsFilter = ({ value, onChange }: Props) => {
	const [error, setError] = useState("");

	const { data: crewsList, isLoading } = useCrews((error) =>
		setError(error.message),
	);

	const options = [
		{ label: "All", value: "all" },
		...(Array.isArray(crewsList)
			? crewsList.map((shift: any) => ({
					label: shift.Crew,
					value: shift.Crew,
				}))
			: []),
	];

	const selectedOption =
		options.find((option) => option.value === (value || "all")) || options[0];

	return (
		<>
			<Autocomplete
				value={selectedOption}
				onChange={(event, newValue) => {
					if (newValue) {
						onChange(newValue.value === "all" ? null : newValue.value);
					}
				}}
				options={options}
				getOptionLabel={(option) => option.label}
				disabled={isLoading}
				disablePortal
				disableClearable
				renderInput={(params) => (
					<TextField
						{...params}
						label="Crew"
						variant="outlined"
						size="small"
						fullWidth
						sx={{
							backgroundColor: (theme) => theme.palette.background.paper,
						}}
					/>
				)}
			/>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
